<template>
  <div class="min-h-screen flex items-start justify-center bg-white relative">
    <div class="w-full max-w-md px-8 slide-up">
      <div class="flex justify-center mt-4">
        <router-link to="/">
          <img
            src="../assets/logo-primary.png"
            alt="IMF Logo"
            class="h-auto w-72 transition-transform duration-300 hover:scale-105"
          />
        </router-link>
      </div>
      <div class="relative bottom-6">
        <h1 class="text-2xl font-extrabold text-center text-zinc-800 mb-4">
          Welcome to <span class="text-orange-600">Registration</span>
        </h1>
        <p class="text-center text-gray-500 mb-6">
          Verification may take up to 24 hours after registration.
        </p>

        <form class="space-y-3" @submit.prevent="handleSubmit()">
          <div class="relative">
            <input
              type="text"
              v-model.trim="firstname"
              placeholder=""
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              First Name
            </label>
          </div>

          <div class="relative">
            <input
              type="text"
              v-model.trim="lastname"
              placeholder=""
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Last Name
            </label>
          </div>

          <div class="relative">
            <input
              type="email"
              v-model.trim="email"
              placeholder=" "
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Email Address
            </label>
          </div>

          <div class="relative">
            <input
              type="text"
              v-model.trim="contactnumber"
              placeholder=" "
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Contact Number
            </label>
          </div>
          <div class="relative" v-if="true">
            <select
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
              v-model="selectedYear"
              id="year"
            >
              <option value="" disabled selected>--Select Year--</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              Year of Birth
            </label>
          </div>
          <div class="relative">
            <input
              type="text"
              v-model.trim="iwccardno"
              class="uppercase peer w-full text-base font-medium bg-white text-gray-800 rounded-2xl px-4 pt-6 pb-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
              required
            />
            <label
              class="absolute left-4 top-2 text-gray-500 text-xs font-medium transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:text-xs peer-focus:top-2"
            >
              IWC Card Number
            </label>
          </div>

          <!-- Circle Avatar Upload -->
          <div class="relative">
            <label
              for="file-upload"
              class="flex items-center justify-center w-32 h-32 rounded-full border-2 border-dashed border-gray-300 cursor-pointer hover:border-orange-400 overflow-hidden bg-gray-50 mx-auto"
            >
              <div
                v-if="!selectedImage"
                class="flex flex-col items-center justify-center text-center"
              >
                <svg
                  class="w-8 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M7 16V4m0 0l-3 3m3-3l3 3M17 8v8a4 4 0 01-4 4H7a4 4 0 01-4-4V8a4 4 0 014-4h3"
                  />
                </svg>
                <p class="text-xs text-gray-500 mt-1">
                  Upload your Profile Photo
                </p>
              </div>

              <img
                v-else
                :src="selectedImage"
                alt="Preview"
                class="w-full h-full object-cover"
              />
            </label>

            <input
              id="file-upload"
              type="file"
              accept="image/*"
              class="hidden"
              required
              @change="handleImageUpload"
            />

            <p class="text-xs text-gray-500 text-center mt-2">
              PNG, JPG up to 15MB
            </p>
          </div>
          <!-- End Avatar Upload -->

          <div class="pt-4">
            <button
              type="submit"
              :disabled="isSubmitting"
              class="w-full py-3 bg-primary hover:bg-hover text-white font-semibold rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <svg
                v-if="isSubmitting"
                class="w-5 h-5 animate-spin text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                />
              </svg>
              <span>{{ isSubmitting ? "Registering..." : "Register" }}</span>
            </button>
          </div>
        </form>

        <div class="mt-6 text-center text-sm text-gray-600">
          Already have an account?
          <router-link
            to="/portal/login"
            class="text-orange-500 hover:underline"
          >
            Sign in here
          </router-link>
        </div>
      </div>
      <div class="text-center text-xs text-zinc-500 pb-4">Version 1.0.0</div>
    </div>
  </div>
</template>

<script>
import { ref, inject, reactive, toRefs, computed } from "vue";
import { useRouter } from "vue-router";
import systemVersion from "@/utils/version";

export default {
  setup() {
    const axios = inject("$axios");
    const Swal = inject("$swal");
    const router = useRouter();
    const selectedYear = ref("");

    const selectedImage = ref(null);
    const selectedFile = ref(null);
    const isSubmitting = ref(false);
    const { appVersion } = systemVersion();

    const formDetails = reactive({
      controlNumber: "",
      firstname: "",
      lastname: "",
      email: "",
      contactnumber: "",
      birthyear: "",
      iwccardno: "",
    });

    const handleImageUpload = (event) => {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        if (file.size <= 15 * 1024 * 1024) {
          selectedFile.value = file;
          selectedImage.value = URL.createObjectURL(file);
        } else {
          Swal.fire("Too Large", "Image must be under 15MB.", "warning");
        }
      } else {
        selectedFile.value = null;
        selectedImage.value = null;
      }
    };

    const handleSubmit = async () => {
      if (isSubmitting.value) return;
      isSubmitting.value = true;
      formDetails.birthyear = selectedYear.value;

      try {
        const formData = new FormData();

        for (const key in formDetails) {
          formData.append(key, formDetails[key]);
        }

        if (selectedFile.value) {
          formData.append("file", selectedFile.value);
        } else {
          Swal.fire("No photo", "Please upload your profile photo.", "warning");
          isSubmitting.value = false;
          return;
        }

        let result = await axios.post("/api/patient/registration", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const isFailed = result.data.status;

        if (!isFailed) {
          Swal.fire({
            icon: "warning",
            title: "Registration Failed",
            text: `The card number you entered is already registered. Please verify your information`,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "🎉 You're Almost In!",
            text: `Thanks for registering! We’re reviewing your information, and once the process is complete, we’ll send your Control Number to your email at ${formDetails.email}.`,
          }).then(() => router.push("/portal/login"));
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: error.response?.data?.message || "Something went wrong.",
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    const years = computed(() => {
      const startYear = 1960;
      const endYear = 2020;
      const arr = [];
      for (let y = endYear; y >= startYear; y--) {
        arr.push(y);
      }
      return arr;
    });

    return {
      ...toRefs(formDetails),
      selectedImage,
      handleImageUpload,
      handleSubmit,
      isSubmitting,
      years,
      selectedYear,
      appVersion,
    };
  },
};
</script>

<style scoped>
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-up {
  animation: slideUp 0.6s ease-out forwards;
}
</style>
